import { render, staticRenderFns } from "./ShareWithFriends.vue?vue&type=template&id=1f14aa58"
import script from "./ShareWithFriends.vue?vue&type=script&lang=js"
export * from "./ShareWithFriends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports